<template>
  <RouterView />
  <Toast />
  <DynamicDialog />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import DynamicDialog from 'primevue/dynamicdialog'
import Toast from 'primevue/toast'
</script>


<style lang="scss">
@import '@/css/styles.scss';
</style>
